<div class="modal-content">
  <div class="text-right">
    <mat-icon class="icon" (click)="cancel()">close</mat-icon>
  </div>

  <div class="content">
    <h2 class="text-center">
      <strong>Force Ingest</strong>
    </h2>
    <p class="message">
      Please specify some key points to justify the force ingest
    </p>

    <form [formGroup]="form">
      <mat-form-field appearance="outline" class="w-100">
        <textarea
          matInput
          rows="5"
          formControlName="analyst_report"
          placeholder="Write comment here..."
        ></textarea>
        <mat-hint align="end" [ngClass]="{ 'count-red': isCharLimitExceeded }">
          {{ charCount }}/{{ maxChars }} chars
        </mat-hint>
      </mat-form-field>
    </form>
  </div>

  <div class="row">
    <button class="btn btn-light hover-clear clear" (click)="proceed()" [disabled]="form.invalid">
      <span>Proceed</span>
    </button>
    <button class="btn btn-light hover-clear clear" (click)="cancel()">
      <span>Cancel</span>
    </button>
  </div>
</div>
